import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MarkupRow from './MarkupRow';
import StrModal from '../shared/StrModal';
import http from '../shared/http';
import * as User from '../user';

const buildAssetSwapV2 = creative => {
  return http
    .get(`/api/internal/creatives/${creative.id}/workaround_banner_tag`)
    .then(({ data }) => data.workaround_banner_tag);
};

class CreativeTagExport extends Component {
  constructor(props) {
    super(props);
    this.buildState = this.buildState.bind(this);
    this.state = {
      creatives: [],
      markupByCreativeId: {}
    };
  }

  componentDidMount() {
    this.buildState().then(newState => this.setState(newState));
  }

  async buildState() {
    const user = await User.getCurrent();
    const creatives = this.props.getCreatives();

    const markupPromises = user.featureEnabled('assetSwapV2')
      ? creatives.map(creative => buildAssetSwapV2(creative))
      : creatives.map(creative =>
          this.props.AdMarkupService.generate(creative)
        );

    return Promise.all(markupPromises)
      .then(markupArray => {
        const markupByCreativeId = {};

        markupArray.forEach((markup, index) => {
          const creative = creatives[index];
          markupByCreativeId[creative.id] = markup;
        }, {});

        return {
          creatives,
          markupByCreativeId
        };
      })
      .catch(() => {
        this.props.FlashService.push(
          'error',
          'Something went wrong creating or retrieving tag assets'
        );
      });
  }

  render() {
    return (
      <StrModal
        modalClasses="export-modal"
        open={this.props.modalOpen}
        hideModal={this.props.hideModal}
        title="Creative Tags"
      >
        {this.state.creatives.map(
          creative =>
            this.state.markupByCreativeId[creative.id] && (
              <MarkupRow
                key={creative.id}
                creative={creative}
                markup={this.state.markupByCreativeId[creative.id]}
              />
            )
        )}
      </StrModal>
    );
  }
}

CreativeTagExport.propTypes = {
  getCreatives: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  AdMarkupService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired
};

CreativeTagExport.defaultProps = {
  modalOpen: false
};

export default CreativeTagExport;
